function positiveId(value) {
    return typeof value === 'number' && Number.isSafeInteger(value) && value > 0 ? value : null;
}
export function createdEntityId(response, beforeIds, afterIds) {
    if (response && typeof response === 'object' && 'id' in response) {
        const responseId = positiveId(response.id);
        if (responseId != null)
            return responseId;
    }
    const before = new Set(beforeIds);
    const added = [...new Set(afterIds)].filter((id) => !before.has(id) && positiveId(id) != null);
    return added.length === 1 ? (added[0] ?? null) : null;
}
